import Spine from 'core/display/Spine'
import Sprite from 'core/display/Sprite'
import { resize } from 'services/ResizeService'
import { signal } from 'services/SignalsService'
import { animationSettings } from 'settings/custom/animations'
import { delayCallBack } from 'utils/Delay'
import { SpineUtils } from 'utils/Spine-Utils'
import { triggerTween } from 'utils/Tweens'

export class TriggerSpine extends Spine {
  constructor(data) {
    super(data)
    this._data = data
    this.scale.set(this._data.scale ? this._data.scale : 1)
    this.settings = animationSettings[this._data.name]
    if(this._data.signal){
      signal.on(this._data.signal, () => {
        this.updateSpineFreeSpin()
      })
    }

    this.current = {
      orientation: 'land',
      state: this.settings.default,
      name: this._data.animation,
      signal: { name: '', delay: 0 },
    }
    this.interactionServise = false

    this.init()

  }

  init() {
    Object.entries(this.settings).forEach(this.subscribe.bind(this))
    if (this._data.oriented) {
      this.oriented.call(this)
    }
    else {
      this.change.call(this)
    }
  }

  oriented() {
    const self = this
    resize()
    signal.on('RESIZE', async function ({ orientation }) {
      self.current.orientation = orientation
      if(self._data.hide){
        self.change()
      }
      else{
        self.change(self.current.state || ['play'])
      }

    })
  }

  change(value) {

    this.current.state = value || this.settings.default

    if(this.current.state[2] ){
      this.current.name = this._data.oriented ? `${this.current.state[2]}-${this.current.orientation}` : this.current.state[2]
    }
    else {
      this.current.name = this._data.animation ?
        this._data.oriented ? `${this._data.animation}-${this.current.orientation}` : this._data.animation : this.current.orientation
    }

    if(this.current.state[3] ){
      if (this.current.state[3].hasOwnProperty('type') && this.current.state[3].type === 'mixin') {
        const stateMix = this.current.state[3]
        this.stateData.setMix(stateMix.from, stateMix.to, stateMix.smooth)
        this.stateData.setMix(stateMix.to, stateMix.from, stateMix.smooth)
        if (stateMix.hasOwnProperty('dispatch')) {
          this.current.signal.name = stateMix.dispatch.name
          this.current.signal.delay = stateMix.dispatch.delay || 0.1
        }
      }
      else {
        this.current.signal.name = this.current.state[3].name
        this.current.signal.delay = this.current.state[3].delay || 0.1
      }
    }

    switch (this.current.state[0]){
      case 'play' : this.makePlay.call(this, this.current.name, this.current.state[1])
        break
      case 'stop' : this.makeStop.call(this, this.current.name)
        break
      case 'end': this.makeStaticEnd.call(this, this.current.name)
        break
      case 'interactive': this.makeInteractiveButton.call(this, this.current.name, this.current.state[1])
        break
      default : this.makeStatic.call(this, this.current.name)
    }
  }

  updateSpineFreeSpin(){
    const action = game.models.SpinModel.get().action
    const texMonkey = game.getTextureFromAtlases(`monkeys_sym_0${this.getRandomInt(1, 10)}`)
    const obj = { texture: texMonkey }

    const monkeySprite = new Sprite(obj)

    const texText = game.getTextureFromAtlases(action)
    const objText = { texture: texText }
    const texSprite = new Sprite(objText)
    SpineUtils.replaceSprite(this, 'symbol_01', monkeySprite, { x: 0, y: 0 }, true)

    SpineUtils.replaceSprite(this, 'paper_01_symbol_01_rabbit', monkeySprite, { x: 0, y: 0 }, true)

    SpineUtils.replaceSprite(this, 'bonus_game', texSprite, { x: -150, y: -20 }, true)
    let ranNums = this.shuffle([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11])
    for (let i = 1; i < 11 ; i++) {
      this.updateSymbolBook(i, ranNums)
    }
  }

  updateSymbolBook(index, array) {
    const texMonkey = game.getTextureFromAtlases(`monkeys_sym_0${array[index]}`)
    const obj = { texture: texMonkey }
    const monkeySprite = new Sprite(obj)

    SpineUtils.replaceSprite(this, `monkey_sym_0${index}`, monkeySprite, { x: -150, y: 0 }, true)
  }

  shuffle(array) {
    let i = array.length
    let j = 0
    let temp

    while (i--) {

      j = Math.floor(Math.random() * (i + 1))

      // swap randomly chosen element with current element
      temp = array[i]
      array[i] = array[j]
      array[j] = temp

    }

    return array
  }

  getRandomInt(min, max) {
    min = Math.ceil(min)
    max = Math.floor(max)
    return Math.floor(Math.random() * (max - min)) + min //Максимум не включается, минимум включается
  }

  makeStaticEnd(name) {
    this.goto(name, 1)
    if(this._data.hide){
      this.visible = false
    }
  }

  makeStatic(name) {
    this.goto(name, 1)
    if(this._data.hide){
      this.visible = false
    }

  }

  makeStop(name) {

    this.stop(name)
    if(this._data.hide){
      this.visible = false
    }
  }

  makeInteractiveButton(name, interactive){
    this.interactionServise = true
    this.makeStatic('0')
    this.enableButton(interactive)
  }

  makePlay(name, loop) {
    if(this._data.tween){
      triggerTween(this, this.settings['tween'])
    }
    if(this._data.hide){
      this.visible = true
    }

    this.stop(name)
    this.setToSetupPose()

    this.dispatchSignalEnd()
    if (this.interactionServise){
      this.enableButton(loop)
    }
    if (name !== undefined && this.state.hasAnimation(name)) {
      this.playCallBack(name, loop, () => {
        if (!loop) {
          this.stop(name)
        }
      })
    }
    else{
      this.playCallBack('animation', loop, () => {
        if (!loop) {
          this.stop('animation')
        }
      })
    }
  }

  dispatchSignalEnd(){
    if(this.current.signal.name !== ''){
      delayCallBack(this.current.signal.delay, () => {
        signal.dispatch(this.current.signal.name)
        if(this.current.signal.name){
          this.current.signal.name = ''
        }
      })
    }
  }

  subscribe([sig, value]) {
    signal.on(sig, () => this.change.call(this, value))
  }
}
